var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactSelectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 6.897 13.103 6 12 6C10.897 6 10 6.897 10 8C10 9.103 10.897 10 12 10C13.103 10 14 9.103 14 8Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11C9.7945 11 8 12.7945 8 15H16C16 12.7945 14.2055 11 12 11Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 15.5C17 15.776 16.7765 16 16.5 16H7.5C7.2235 16 7 15.776 7 15.5V15C7 12.896 8.308 11.095 10.152 10.3585C9.452 9.8085 9 8.957 9 8C9 6.3455 10.3455 5 12 5C13.6545 5 15 6.3455 15 8C15 8.957 14.548 9.8085 13.848 10.3585C15.692 11.095 17 12.896 17 15V15.5ZM21 2H3C1.897 2 1 2.897 1 4V17C1 18.103 1.897 19 3 19H5V22.5C5 22.702 5.1215 22.8845 5.3085 22.962C5.3705 22.9875 5.4355 23 5.5 23C5.63 23 5.758 22.949 5.8535 22.8535L9.707 19H21C22.103 19 23 18.103 23 17V4C23 2.897 22.103 2 21 2Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSelectedIcon);
export default __webpack_public_path__ + "static/media/contact-selected-icon.2ef81cc8f714445212abaa0db277de1a.svg";
export { ForwardRef as ReactComponent };